"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InheritedColumnOptionsOverride = void 0;
const typeorm_1 = require("typeorm/browser");
function InheritedColumnOptionsOverride(optionsProcessor) {
    return function (target) {
        const proto = Object.getPrototypeOf(target);
        if (!proto || !proto.name) {
            return;
        }
        const overrideColumns = (0, typeorm_1.getMetadataArgsStorage)()
            .columns
            .filter((columnMeta) => columnMeta.target === proto)
            .map((columnMeta) => {
            const overriddenOptions = optionsProcessor(columnMeta.options);
            if (overriddenOptions) {
                return {
                    target: target,
                    propertyName: columnMeta.propertyName,
                    mode: columnMeta.mode,
                    options: overriddenOptions,
                };
            }
        })
            .filter((o) => o);
        if (overrideColumns) {
            (0, typeorm_1.getMetadataArgsStorage)().columns.unshift(...overrideColumns);
        }
    };
}
exports.InheritedColumnOptionsOverride = InheritedColumnOptionsOverride;
//# sourceMappingURL=inherited-column-options-override.js.map